import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../assets/store";
import { Navigate } from "react-router-dom";
import Loader from "./ui/loader";

interface PrivateRouteProps {
  children: ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { accessToken, loading } = useSelector((state: RootState) => state.auth);

  if (loading) return <Loader />;
  if (!accessToken) return <Navigate to="/sign-in" replace />;

  return <>{children}</>;
};

export default PrivateRoute;